import { NextPageContext } from 'next';

import ListCollection from 'types/redux/ListCollection';

import Article, { Roles } from 'models/Article';
import ArticleCategory from 'models/ArticleCategory';
import CmsPage from 'models/CmsPage';
import Job from 'models/Job';

import { LIST_MARKUP } from 'consts/redux';

import { list as listArticles, single } from 'requests/articles';
import { list as listArticlesCategories } from 'requests/articlesCategories';
import { single as singleCmsPage } from 'requests/cmsPages';
import { list as listJobs } from 'requests/jobs';

import Component from './component';
import { Props } from './types';

Component.getInitialProps = async (appContext: NextPageContext): Promise<Props> => {
    let article: Article = null;
    let articleCategories: ListCollection<ArticleCategory> = LIST_MARKUP;
    let tutorials: ListCollection<Article> = LIST_MARKUP;
    let jobs: ListCollection<Job> = LIST_MARKUP;
    let cmsPage: CmsPage = null;

    try {
        await Promise.all([
            single({ slug: appContext?.query?.slug.toString() }),
            listArticlesCategories({ page: 1, perPage: 999 }),
            listArticles({ page: 1, perPage: 6, role: Roles.Worker, categorySlug: 'szkolenia' }),
            listJobs({ page: 1, perPage: 6 }),
            singleCmsPage({ slug: 'articleemployee' }),
        ]).then(responses => {
            article = responses[0];
            articleCategories = responses[1];
            tutorials = responses[2];
            jobs = responses[3];
            cmsPage = responses[4];
        });
    } catch (error) {
        console.error(error);
        return {
            notFound: true,
        };
    }

    return {
        tutorials: tutorials.elements || null,
        article,
        articleCategories: articleCategories.elements || null,
        jobs: jobs.elements || null,
        cmsPage: cmsPage || null,
    };
};

export default Component;
